import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { ElMessage } from 'element-plus';
import { defineComponent, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { loginTip } from '@/config/constant';
import { checkEmail, checkPassword, checkVerifyCode, checkRepeatPassword, checkPasswordStatus } from '@/utils/validate';
import UserService from '@/api/user';
export default defineComponent({
  props: {
    operation: {
      type: String,
      default: ''
    },
    loginText: {
      type: String,
      default: ''
    },
    loginWarn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bindCode: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var router = useRouter();
    var formRef = ref();
    var resetFormRef = ref();
    var nameError = ref('');
    var pwdError = ref('');
    var repeatPwdError = ref('');
    var passwordType = ref('password');
    var repeatPasswordType = ref('password');
    var resetStage = ref(1);
    var verifyCodeError = ref('');
    var hasSentCode = ref(false);
    var verifyCodeTimer = ref(60);
    var formState = reactive({
      name: '',
      password: '',
      verifyCode: '',
      repeatPassword: ''
    }); // 校验邮箱

    var validateName = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nameError.value = checkEmail(value.trim());
                nameError.value ? callback(nameError.value) : callback();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function validateName(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }(); // 校验验证码


    var validateVerifyCode = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verifyCodeError.value = checkVerifyCode(value.trim());
                verifyCodeError.value ? callback(verifyCodeError.value) : callback();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function validateVerifyCode(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }(); // 校验密码


    var validatePassword = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pwdError.value = checkPassword(value);
                pwdError.value ? callback(pwdError.value) : callback();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function validatePassword(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      };
    }(); // 校验确认密码


    var validateRepeatPassword = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                repeatPwdError.value = checkRepeatPassword(value, formState.password);
                repeatPwdError.value ? callback(repeatPwdError.value) : callback();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function validateRepeatPassword(_x10, _x11, _x12) {
        return _ref4.apply(this, arguments);
      };
    }(); // 校验规则


    var accountRules = {
      name: [{
        validator: validateName,
        trigger: 'blur'
      }],
      verifyCode: [{
        validator: validateVerifyCode,
        trigger: 'blur'
      }]
    }; // 校验规则

    var passwordRules = {
      password: [{
        validator: validatePassword,
        trigger: 'blur'
      }],
      repeatPassword: [{
        validator: validateRepeatPassword,
        trigger: 'blur'
      }]
    };

    var goRegister = function goRegister() {
      router.push("/register".concat(props.bindCode ? "?bind_code=".concat(props.bindCode) : ""));
    };

    var handleFinishForget = function handleFinishForget(formEl) {
      if (!formEl) return;
      formEl.validate(function (valid) {
        if (valid) {
          resetStage.value = 2;
        } else {
          return false;
        }
      });
    }; // 重置密码


    var handleFinishReset = function handleFinishReset(formEl) {
      if (!formEl) return;
      formEl.validate( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          var _data$data, data;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!valid) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.next = 3;
                  return UserService.resetPassword({
                    email: formState.name.trim(),
                    password: formState.password,
                    verification_code: formState.verifyCode.trim() // 验证码

                  });

                case 3:
                  data = _context5.sent;

                  if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                    resetStage.value = 3;
                  } else {
                    ElMessage({
                      message: data.data.msg,
                      type: 'error'
                    });
                  }

                  _context5.next = 8;
                  break;

                case 7:
                  return _context5.abrupt("return", false);

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x13) {
          return _ref5.apply(this, arguments);
        };
      }());
    }; // 切换密码显示


    var togglePasswordType = function togglePasswordType() {
      passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
    }; // 切换密码显示


    var toggleRepeatPasswordType = function toggleRepeatPasswordType() {
      repeatPasswordType.value = repeatPasswordType.value === 'password' ? 'text' : 'password';
    }; // 发送验证码


    var sendVerifyCode = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _data$data2;

        var data, timer;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                hasSentCode.value = true;
                _context6.next = 3;
                return UserService.sendVerificationCodeForResetPwd({
                  send_type: 'EMAIL',
                  receive_address: formState.name.trim()
                });

              case 3:
                data = _context6.sent;
                timer = window.setInterval(function () {
                  if (verifyCodeTimer.value > 0) {
                    verifyCodeTimer.value = verifyCodeTimer.value - 1;
                  } else {
                    clearInterval(timer);
                    hasSentCode.value = false;
                    verifyCodeTimer.value = 60;
                  }
                }, 1000);

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  ElMessage({
                    message: loginTip.sendCodeSuccess,
                    type: 'success'
                  });
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function sendVerifyCode() {
        return _ref6.apply(this, arguments);
      };
    }();

    var validatePasswordStatus = function validatePasswordStatus() {
      return checkPasswordStatus(formState.password);
    };

    var goLogin = function goLogin() {
      var redirectUrl = route.query.redirect_url ? "?from=wxlogin&redirect_url=".concat(encodeURIComponent(route.query.redirect_url.toString() || '')) : '?from=wxlogin';
      router.push("/login".concat(redirectUrl));
    };

    var goPrev = function goPrev() {
      resetStage.value = 1;
    };

    return {
      formState: formState,
      formRef: formRef,
      resetFormRef: resetFormRef,
      nameError: nameError,
      pwdError: pwdError,
      repeatPwdError: repeatPwdError,
      verifyCodeError: verifyCodeError,
      passwordType: passwordType,
      repeatPasswordType: repeatPasswordType,
      resetStage: resetStage,
      hasSentCode: hasSentCode,
      verifyCodeTimer: verifyCodeTimer,
      accountRules: accountRules,
      passwordRules: passwordRules,
      goRegister: goRegister,
      sendVerifyCode: sendVerifyCode,
      handleFinishReset: handleFinishReset,
      handleFinishForget: handleFinishForget,
      validatePasswordStatus: validatePasswordStatus,
      togglePasswordType: togglePasswordType,
      toggleRepeatPasswordType: toggleRepeatPasswordType,
      goPrev: goPrev,
      goLogin: goLogin,
      checkEmail: checkEmail
    };
  }
});